import type { StatusTone } from '../contracts/common';
import type { CompanyRegistryField, CompanyRegistrySource, CompanyVatStatus } from '../contracts/company-registry';
import type { ClientStatus, ContactConflictDecision } from '../contracts/crm';

export const CLIENT_STATUS_LABELS: Record<ClientStatus, string> = {
  prospect: 'Potencjalny',
  active: 'Aktywny',
  inactive: 'Nieaktywny',
  archived: 'Archiwalny',
};

/** Zakładki listy klientów (Figma 05 Klienci): Aktywni, Potencjalni, Archiwum. */
export const CLIENT_STATUS_PLURAL_LABELS: Record<ClientStatus, string> = {
  prospect: 'Potencjalni',
  active: 'Aktywni',
  inactive: 'Nieaktywni',
  archived: 'Archiwum',
};

export const CLIENT_STATUS_TONES: Record<ClientStatus, StatusTone> = {
  prospect: 'accent',
  active: 'success',
  inactive: 'neutral',
  archived: 'neutral',
};

/** Nazwy kolorów z palety klientów (CLIENT_COLOR_PALETTE) dla czytników ekranu. */
export const CLIENT_COLOR_LABELS: Record<string, string> = {
  '#2B3BFF': 'Kobaltowy',
  '#E8466B': 'Malinowy',
  '#6E56CF': 'Fioletowy',
  '#14915A': 'Zielony',
  '#12A5A5': 'Morski',
};

/** Rozstrzygnięcie konfliktu emaila kontaktu (Etap 1: ten sam email u dwóch klientów). */
export const CONTACT_CONFLICT_DECISION_LABELS: Record<ContactConflictDecision, string> = {
  same_person: 'To ta sama osoba',
  different_people: 'To różne osoby',
};

// ── Dane firmy z rejestru (Fala 7, DECISIONS 6.10.2026 „Dane firmy po NIP”) ─────────────────────────────────

/** Status VAT z Białej listy. */
export const COMPANY_VAT_STATUS_LABELS: Record<CompanyVatStatus, string> = {
  active: 'Czynny podatnik VAT',
  exempt: 'Zwolniony z VAT',
  unregistered: 'Niezarejestrowany w VAT',
  unknown: 'Status VAT nieznany',
};

/** Kolor tylko, gdy znaczy (DESIGN: spokojnie): czynny = zwykły, zwolniony / niezarejestrowany = ostrzeżenie. */
export const COMPANY_VAT_STATUS_TONES: Record<CompanyVatStatus, StatusTone> = {
  active: 'neutral',
  exempt: 'warning',
  unregistered: 'warning',
  unknown: 'neutral',
};

/** Źródło danych firmy („Biała lista VAT, 6.10.2026”). */
export const COMPANY_REGISTRY_SOURCE_LABELS: Record<CompanyRegistrySource, string> = {
  mf_whitelist: 'Biała lista VAT',
  gus_regon: 'REGON (GUS)',
  fake: 'Symulacja (dane przykładowe)',
};

/** Pola danych firmy (porównanie „Odśwież dane z rejestru”). */
export const COMPANY_REGISTRY_FIELD_LABELS: Record<CompanyRegistryField, string> = {
  legalName: 'Nazwa prawna',
  regon: 'REGON',
  krs: 'KRS',
  vatStatus: 'Status VAT',
  address: 'Adres siedziby',
};
